export function normalizeChainId(chainId: string | number | bigint) {
  if (typeof chainId === 'string')
    return Number.parseInt(chainId, chainId.trim().substring(0, 2) === '0x' ? 16 : 10)
  if (typeof chainId === 'bigint') return Number(chainId)
  return chainId
}

export const showValueIfUserLoggedIn =
  (isAuthenticated: boolean) => (value: string | number) =>
    isAuthenticated ? value.toString() : 'N/A'

export const getNonceMessage = () => {
  const nonce = Math.floor(Math.random() * 1000000).toString()

  return `CONNECT TO WEBSITE
  - We will send you request about transactions
  - We will be able to see your wallet balance
  - Every time you want to invest you will have to approve transaction

  Request ID: ${nonce}`
}
